// React
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useHistory} from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import {useFormik} from 'formik';

// Containers Injection
import {notifyError} from '../../containers/componentsInjection';
import {ReportsInjection} from '../../containers/reportsInjection';

// Utils
import {useLoading} from '../../../../hook/useLoading';
import {createData} from '../../../../utils/createData';
import {APIClient} from '../../../../helpers/api_helper';

// View
import {ProposalsBySellerPage} from './view';
import {openPdfWithBase64} from '../../../../utils/openPdfWithBase64';

export const ProposalsBySeller = () => {
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    const {
        sellers,
        getSellers,
        categoryPlans,
        organizations,
        reportsBySeller,
        getOrganizations,
        getCategoryPlans,
        proposalBySeller,
    } = ReportsInjection();

    const api = new APIClient();
    const history = useHistory();
    const {toggleLoading, setLoading} = useLoading();

    const dataCadastralStatus = useMemo(
        () => [
            {
                value: '1',
                label: 'Contratado',
            },
            {
                value: '2',
                label: 'Efetivo',
            },
            {
                value: '3',
                label: 'Aposentado',
            },
            {
                value: '4',
                label: 'Cancelado',
            },
            {
                value: '5',
                label: 'Inativo',
            },
        ],
        []
    );

    const getOptionsToDepartmentInput = useCallback(async (idOrganization) => {
        await api
            .get(`/register/unit/find-by-organization/${idOrganization}`)
            .then((options) => {
                setDepartmentOptions(createData(options));
            });
    }, []);

    const getProposalStatus = async () => {
        await api.get('/proposal/get-status').then((status) => {
            setStatusOptions(createData(status));
        });
    };

    const resetDepartmentInput = () => {
        if (validation.values.departmentInput) {
            validation.handleChange({
                target: {
                    name: 'departmentInput',
                    value: {
                        label: '',
                        value: '',
                    },
                },
            });
        }
    };

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            periodStarts: '',
            periodEnds: '',
            periodType: 'sale',
            sellerInput: {
                label: '',
                value: '',
            },
            categoryPlanInput: [],
            organizationInput: '',
            departmentInput: '',
            proposalSituationInput: [],
            employeeSituationInput: [],
        },
        validationSchema: Yup.object({
            periodStarts: Yup.string(),
            periodEnds: Yup.string(),
            periodType: Yup.string(),
            sellerInput: Yup.object().shape({
                label: Yup.string(),
                value: Yup.string(),
            }),
            categoryPlanInput: Yup.array(),
            organizationInput: Yup.object().shape({
                label: Yup.string(),
                value: Yup.string(),
            }),
            departmentInput: Yup.object().shape({
                label: Yup.string(),
                value: Yup.string(),
            }),
            proposalSituationInput: Yup.array(),
            employeeSituationInput: Yup.array(),
        }),

        onSubmit: (values) => {
            let proposalStatusArray = values.proposalSituationInput.map((item) => {
                return item.value;
            });

            let categoryPlansArray = values.categoryPlanInput.map((item) => {
                return item.value;
            });

            let cadastralStatusArray = values.employeeSituationInput.map((item) => {
                return item.value;
            });

            const valuesToSubmit = {
                starts: values.periodStarts || null,
                ends: values.periodEnds || null,
                periodType: values.periodType || null,
                plan_category_id: categoryPlansArray || null,
                seller_id: values.sellerInput.value || null,
                organization_id: values.organizationInput.value || null,
                unit_id: values.departmentInput.value || null,
                proposal_status_id: proposalStatusArray || null,
                cadastral_status: cadastralStatusArray || null,
            };

            toggleLoading();
            api
                .create('/reports/proposal/by-seller', valuesToSubmit)
                .then((response) => {
                    openPdfWithBase64(response.data, 'Impressão de cartão');
                })
                .catch((error) => {
                    notifyError(error.response.data.messages.error);
                })
                .finally(() => {
                    setLoading(false);
                });
        },
    });

    useEffect(() => {
        if (validation.values.organizationInput.value) {
            getOptionsToDepartmentInput(validation.values.organizationInput.value);
        } else {
            setDepartmentOptions([]);
        }
    }, [getOptionsToDepartmentInput, validation.values.organizationInput]);

    useEffect(() => {
        getSellers();
        getCategoryPlans();
        getOrganizations();
        getProposalStatus();
    }, []);

    return (
        <ProposalsBySellerPage
            history={history}
            createData={createData}
            validation={validation}
            resetDepartmentInput={resetDepartmentInput}
            // Data
            sellers={sellers || []}
            organizations={organizations || []}
            categoryPlans={categoryPlans || []}
            statusOptions={statusOptions || []}
            departmentOptions={departmentOptions || []}
            dataCadastralStatus={dataCadastralStatus}
        />
    );
};